import React from "react";
import { FaCalendarAlt, FaGraduationCap } from "react-icons/fa";
import "../../assets/style/Qualification.css";
import { useTranslation } from "react-i18next";

const Education: React.FC = () => {
  const { t } = useTranslation("fr", { useSuspense: false });

  return (
    <div className="education">
      <h3 className="qualification__title">
        <FaGraduationCap size={20} /> {t("education.educationTitle")}
      </h3>

      <div className="timeline">
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("education.bigDataFormation")}</h3>
          <p className="timeline__text">{t("education.bigDataFormationDescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />{t("education.bigDataFormationDate")}</span>
        </div>
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("education.aiInitiation")}</h3>
          <p className="timeline__text">{t("education.aiInitiationDescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />{t("education.aiInitiationDate")}</span>
        </div>
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("education.masterFirstYear")}</h3>
          <p className="timeline__text">{t("education.masterFirstYearDescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />{t("education.masterFirstYearDate")}</span>
        </div>
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("education.dataCollectionCert")}</h3>
          <p className="timeline__text">{t("education.dataCollectionCertDescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />{t("education.dataCollectionCertDate")}</span>
        </div>
         <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("education.bachelorDegree")}</h3>
          <p className="timeline__text">{t("education.bachelorDegreeDescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />2022 - 2023</span>
        </div>
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("experience.iotInitiation")}</h3>
          <p className="timeline__text">{t("experience.iotInitiationDescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />{t("experience.iotInitiationDate")}</span>
        </div>
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("experience.professionalTrainingAtSAYNA")}</h3>
          <p className="timeline__text">{t("experience.professionalTrainingAtSAYNADescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />{t("experience.professionalTrainingAtSAYNADate")}</span>
        </div>
        <div className="timeline__item">
          <div className="circle__dot"></div>
          <h3 className="timeline__title">{t("education.highSchoolDiploma")}</h3>
          <p className="timeline__text">{t("education.highSchoolDiplomaDescription")}</p>
          <span className="timeline__date"><FaCalendarAlt size={15} />2018-2019</span>
        </div>
      </div>
    </div>
  );
};

export default Education;
